<h2 mat-dialog-title>Bloquear dia não trabalhado</h2>

<div mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="row g-3">
    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Data</mat-label>
        <input matInput  [matDatepickerFilter]="dateFilter" [matDatepicker]="dp1" formControlName="date" />
        <mat-datepicker-toggle matSuffix    [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>

        <mat-error *ngIf="form.get('date')?.touched && form.get('date')?.hasError('required')">
          Informe a data
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="type">
          <mat-option *ngFor="let t of typeOptions" [value]="t.value">
            {{ t.label }}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="form.get('type')?.touched && form.get('type')?.hasError('required')">
          Selecione o tipo
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button (click)="close()" [disabled]="loading">
    Fechar
  </button>

  <button
    mat-flat-button
    color="primary"
    (click)="addBlockDays()"
    [disabled]="form.invalid || loading"
  >
    <mat-icon>add</mat-icon>
    Adicionar
  </button>
</div>
